/**
 * Zepto Product Personalizer i18n Override
 * --------------------------------------------------------------
 * Ersetzt clientseitig die in Zepto hinterlegten Tooltip-Texte
 * und Field-Labels durch lokalisierte Versionen, ohne dass im
 * Zepto-Admin pro Template gepflegt werden muss.
 *
 * Zwei Funktionen in einem:
 *   1) DE-Override: einheitliche / erweiterte deutsche Texte
 *      (z. B. der Stufentiefe-Hinweis bekommt überall den
 *      "WICHTIG: Innenmaß ohne Vorderkante"-Zusatz).
 *   2) PL-Übersetzung: für Locale = pl wird der polnische Text
 *      eingesetzt.
 *
 * Pflege: Nur diese Datei. Source of Truth = das TRANSLATIONS-
 * Objekt unten. Beim Hinzufügen neuer Tooltips/Labels einfach
 * neue Einträge anlegen.
 *
 * Stand: 2026-04-29  /  schodyhafa.pl  /  HAFA Stairs
 */
(function () {
  "use strict";

  // ---------- Translations Map ----------
  // Key  = aktueller Source-Text aus Zepto (deutsch, wie heute hinterlegt)
  // Wert = { de: <Override-Text>, pl: <polnische Übersetzung> }
  // Wenn ein Locale-Eintrag fehlt, wird die jeweilige Sprache übersprungen
  // (kein Replace = Source-Text bleibt sichtbar).
  var TRANSLATIONS = {
    // ===== Tooltips =====
    // Stufentiefe (kurz) — wird sowohl in DE als auch PL durch die
    // erweiterte Variante mit "WICHTIG: Innenmaß ohne Vorderkante" ersetzt.
    "Sollte mindestens so tief sein, wie die zu renovierende Stufe. Messen Sie bei teilweise gewendelten Treppenstufen die tiefste Stelle.": {
      de: "Sollte mindestens so tief sein, wie die zu renovierende Stufe. Messen Sie bei teilweise gewendelten Treppenstufen die tiefste Stelle. WICHTIG: die Tiefe bezieht sich auf das Innenmaß der Renovierungsstufe, also ohne die Vorderkante!",
      pl: "Powinna być co najmniej tak głęboka jak stopień przeznaczony do renowacji. Przy schodach częściowo skręconych mierz w najgłębszym miejscu. WAŻNE: głębokość odnosi się do wymiaru wewnętrznego stopnia renowacyjnego, czyli bez krawędzi przedniej!"
    },

    // Stufentiefe (lang, bereits mit WICHTIG-Zusatz) — DE bleibt; nur PL.
    "Sollte mindestens so tief sein, wie die zu renovierende Stufe. Messen Sie bei teilweise gewendelten Treppenstufen die tiefste Stelle. WICHTIG: die Tiefe bezieht sich auf das Innenmaß der Renovierungsstufe, also ohne die Vorderkante!": {
      pl: "Powinna być co najmniej tak głęboka jak stopień przeznaczony do renowacji. Przy schodach częściowo skręconych mierz w najgłębszym miejscu. WAŻNE: głębokość odnosi się do wymiaru wewnętrznego stopnia renowacyjnego, czyli bez krawędzi przedniej!"
    },

    // Stufenbreite
    "Sollte mindestens so breit sein wie die zu renovierende Stufe, ggf. können Sie auch aus einem Stufenelement 2 Treppenstufen schneiden.": {
      pl: "Powinna być co najmniej tak szeroka jak stopień przeznaczony do renowacji. W razie potrzeby z jednego elementu stopnia można wyciąć 2 stopnie."
    },

    // Stellstufe
    "Vertikales Brett zwischen zwei Trittstufen – macht die Treppe geschlossen.": {
      pl: "Pionowy element pomiędzy dwiema stopnicami – sprawia, że schody są zamknięte."
    },

    // LED Streifen
    "Breite der LED Streifen": {
      pl: "Szerokość taśmy LED"
    },

    // LED Stufenbeleuchtung
    "Planen Sie bei der Treppenrenovierung eine Stufenbeleuchtung zu verbauen?": {
      pl: "Czy planujesz zamontować oświetlenie stopni przy renowacji schodów?"
    },

    // ===== Field-Labels (frontend-sichtbar) =====
    "Stufentiefe in cm":           { pl: "Głębokość stopnia w cm" },
    "Stufenbreite in cm":          { pl: "Szerokość stopnia w cm" },
    "Stellstufe":                  { pl: "Podstopnica" },
    "LED Stufenbeleuchtung":       { pl: "Oświetlenie stopni LED" },
    "Profile für LED Beleuchtung": { pl: "Profile do oświetlenia LED" },
    "LED Beleuchtung":             { pl: "Oświetlenie LED" },
    "LED Beleuchtung U":           { pl: "Oświetlenie LED U" },
    "LED Beleuchtung L":           { pl: "Oświetlenie LED L" },
    "Aluprofile 80":               { pl: "Profile aluminiowe 80" },
    "Aluprofile 100":              { pl: "Profile aluminiowe 100" },
    "Aluprofile 130":              { pl: "Profile aluminiowe 130" },
    "Aluprofile 160":              { pl: "Profile aluminiowe 160" },
    "Aluprofile 180":              { pl: "Profile aluminiowe 180" },

    // ===== Tab-Headings (Zepto-Tabs oben am Konfigurator) =====
    "Maße":                        { pl: "Wymiary" },
    "Montageprofil":               { pl: "Profil montażowy" },
    "Fertig":                      { pl: "Gotowe" }

    // Zum Erweitern einfach hier neue Zeilen hinzufügen. Format:
    // "deutscher Source-Text": { de: "DE-Override", pl: "PL-Übersetzung" }
  };

  // ---------- Locale-Detection ----------
  function getLocale() {
    var lang = (document.documentElement.lang || "de").toLowerCase().split("-")[0];
    return lang;
  }

  // ---------- Replace logic ----------
  // Ersetzt einen einzelnen Text-Node, falls Übersetzung existiert.
  function replaceTextNode(node, locale) {
    if (!node || node.nodeType !== 3) return;
    var orig = node.textContent.trim();
    if (!orig) return;
    var entry = TRANSLATIONS[orig];
    if (!entry) return;
    var newText = entry[locale];
    if (!newText || newText === orig) return;
    // Erhalte führende/folgende Whitespaces
    node.textContent = node.textContent.replace(orig, newText);
  }

  // Findet den ersten signifikanten Text-Node innerhalb eines Elements
  // (für Field-Labels, deren erster TextNode das Label ist).
  function firstTextNode(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) return n;
    }
    return null;
  }

  function applyTranslations() {
    var locale = getLocale();

    // 1. Tooltips: .ptooltiptext — nur erste Text-Node ersetzen,
    //    die Pfeil-Span (.ptooltiparrow) bleibt erhalten.
    document.querySelectorAll(".ptooltiptext").forEach(function (el) {
      replaceTextNode(firstTextNode(el), locale);
    });

    // 2. Field-Labels: .pplrlabel — erste Text-Node ist das Label.
    document.querySelectorAll(".pplrlabel").forEach(function (el) {
      replaceTextNode(firstTextNode(el), locale);
    });

    // 3. Generischer Pass: Texte im gesamten Zepto-Container, falls
    //    Tab-Headings oder andere Strings in unbekannten Klassen liegen.
    var zeptoRoot = document.querySelector(".product-personalizer");
    if (zeptoRoot) {
      var walker = document.createTreeWalker(zeptoRoot, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          var t = n.textContent.trim();
          if (!t || !TRANSLATIONS[t]) return NodeFilter.FILTER_REJECT;
          // Skip if already inside .ptooltiptext or .pplrlabel
          // (already handled above, no double-touch)
          var p = n.parentElement;
          while (p && p !== zeptoRoot) {
            if (p.classList && (p.classList.contains("ptooltiptext") || p.classList.contains("pplrlabel"))) {
              return NodeFilter.FILTER_REJECT;
            }
            p = p.parentElement;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var nodes = [];
      var cur;
      while ((cur = walker.nextNode())) nodes.push(cur);
      nodes.forEach(function (n) { replaceTextNode(n, locale); });
    }
  }

  // ---------- Bootstrap ----------
  function init() {
    applyTranslations();

    // Zepto rendert oft asynchron / progressive. Mehrfach abwarten.
    var retries = [200, 600, 1500, 3000, 6000];
    retries.forEach(function (ms) { setTimeout(applyTranslations, ms); });

    // Mutation-Observer für nachträgliche Renderings (z. B. Tab-Wechsel
    // im Konfigurator, dynamisch nachgeladene Sections).
    if (typeof MutationObserver === "undefined") return;
    var debounce = null;
    var observer = new MutationObserver(function (mutations) {
      // Nur reagieren, wenn ein Zepto-relevantes Element hinzugefügt wurde.
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || m.addedNodes.length === 0) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (
            n.classList && (
              n.classList.contains("ptooltiptext") ||
              n.classList.contains("pplrlabel") ||
              n.classList.contains("product-personalizer")
            ) ||
            (n.querySelector && n.querySelector(".ptooltiptext, .pplrlabel, .product-personalizer"))
          ) {
            relevant = true;
            break;
          }
        }
        if (relevant) break;
      }
      if (!relevant) return;
      if (debounce) clearTimeout(debounce);
      debounce = setTimeout(applyTranslations, 80);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
